import { RootState } from '@store/reducers';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import './otp.css';
import Time from "../../../UserManagement/CreateNewUser/VerificationCard/time";
import Button from '@components/common/Button';
import InputFieldsComponent from '@components/common/InputFieldsSmall';
import endpoints from '@config/endpoints';
import { getData, postDataJSON } from '../../../../services/CommonApiService';
import { Modal, Spinner } from 'react-bootstrap';
import { beneficiaryAlreadyInRCH, setBeneficiaryData, setTsnID, setTxnIdForAbhaAddress, setAbhaAddress, setPrimaryNoForRCH, updateChild } from '@store/actions/beneficiaryAction';
import { encodeWithKeyAndShift, decodeWithKeyAndShift } from '../../../../utils/base64Utils';
import { toast } from 'react-toastify';
import { errorLogger } from '@utils/applicationLogUtils';
import { benef_const, benef_error_const } from '@constants/beneficiaryConstant';
import { GENDER } from '@constants/index';
import dayjs from 'dayjs';
import { prepareBeneficiaryImageForDisplay } from '@utils/childUtils';
import { startOtpCooldown, isOtpRateLimitedError, useOtpCooldown } from '@hooks/useOtpCooldown';
import { otpCooldownMessage } from '@constants/appConstants';
interface showModalProps {
    showModal: boolean;
    handleClose: (authType: string,abhaNumber?:any, mobileNumber?:any, abhaAddress?:any, benefDetails?:any) => void;
    setLinkedBenefDetails:Dispatch<SetStateAction<string>>;
};

const OTPModal = ({ showModal, handleClose, setLinkedBenefDetails }: showModalProps) => {

    const [selectedInputFieldValue, setSelectedInputFieldValue] = useState<string[]>([]);
    const [isOTPErrorCheck, setIsOTPErrorCheck] = useState<boolean>(true);
    const [index, setIndex] = useState<number>(0);
    const [otpWrong, setOtpWrong] = useState<string>('');
    const [maxLimitMessage, setMaxLimitMessage] = useState<string>('');
    const [invalidGenderMessage, setInvalidGenderMessage] = useState<string>('');
    const [showSpinner, setSHowSpinner] = useState<boolean>(false);
    const [resetKey, setResetKey] = useState<number>(0);
    const [retryMessage, setRetryMessage] = useState<string>('');
    const [retry, setRetry] = useState<number>(benef_const.defalut_retry);
    const [isTimeFinished, setIsTimeFinished] = useState<boolean>(false);
    const mobNumber = useSelector((state: RootState) => state.beneficiary?.beneficiaryMobileNumber);
    const aadharTxnId = useSelector((state: RootState) => state.beneficiary?.tsnId);
    const aadhar = useSelector((state: RootState) => state.beneficiary?.aadhar);
    const beneficiary = useSelector((state: RootState) => state.beneficiary);
    const abhaTxnId = useSelector((state: RootState) => state.beneficiary?.tsnId);
    const abha = useSelector((state: RootState) => state.beneficiary?.abha);
    const isChildRegistration = useSelector((state: RootState) => state.beneficiary.isChildRegistration);
    const abhaValue: any = abha;
    const otpCooldownIdentifier =
        beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.phoneNumber
            ? mobNumber?.split(' ')?.pop()
            : beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.abha
                ? (typeof abhaValue === 'string' ? abhaValue : abhaValue?.abhaNumber)?.replace(/-/g, '')
                : aadhar;
    const { secondsLeft, isCoolingDown } = useOtpCooldown(otpCooldownIdentifier);

    const createErrorMessage = (abdmMessage: string, rchMessage?: string) => (
            <div>
                <p><strong>ABDM:</strong> {abdmMessage}</p>
                {rchMessage && <p><strong>JANANI:</strong> {rchMessage}</p>}
            </div>
        );
    
        const handleError = (message: string, rchMessage?: string) => {
            const errorMessage = createErrorMessage(message, rchMessage);
            toast.error(errorMessage, {
                position: "top-center",
            });
        };

    useEffect(() => {
    }, [otpWrong])
    
    const handleSave2 = async () => {
        if (selectedInputFieldValue.length === 6) {
            const result = Object.values(selectedInputFieldValue).join('');
            if (beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.phoneNumber) {
                
                const data = {
                    "otp": result,
                    "txnId": aadharTxnId
                }
                try {
                    setSHowSpinner(true);
                    const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data));
                    const otpResponse = await postDataJSON<any>(`${endpoints.verifyAbhaByMobileNumberVerifyOtp}`, { data: encodedPayload })
                    setSHowSpinner(false);
                    const decodedData = JSON.parse(decodeWithKeyAndShift(otpResponse.data));
                    if (decodedData.authResult === benef_const.success) {
                        dispatch(setTxnIdForAbhaAddress(decodedData.txnId ?? ''))
                        dispatch(setPrimaryNoForRCH(mobNumber.split(' ')[mobNumber.split(' ').length-1]));
                            const beneficiaryData = []
                            for (let i = 0; i < decodedData?.accounts?.length; i++) {
                                const data = {
                                    name: decodedData.accounts[i].name,
                                    abhaId: decodedData.accounts[i].ABHANumber.replace('-', ''),
                                    gender: decodedData.accounts[i].gender,
                                    dob: decodedData.accounts[i].dob,
                                    address: decodedData.accounts[i].preferredAbhaAddress,
                                    profile: decodedData.accounts[i].profilePhoto,
                                    mob:mobNumber.split(' ')[mobNumber.split(' ').length-1],
                                    kycVerified: decodedData.accounts[i].kycVerified
                                }
                                beneficiaryData.push(data)
                            }
                            dispatch(setBeneficiaryData(beneficiaryData));
                            setIsOTPErrorCheck(false);
                            setMaxLimitMessage('')
                            setSelectedInputFieldValue(Array(6).fill(''));
                            setRetryMessage('');
                            setRetry(benef_const.defalut_retry);
                            handleClose('submit');
                    }
                    else {
                        if (retry >= 0) {
                            setOtpWrong(decodedData?.message || '')
                        }
                        else {
                            setMaxLimitMessage(benef_const.otpLimitReached)
                        }
                    }
                }
                catch (error) {
                    setSHowSpinner(false);
                    if (retry >= 0) {
                        setOtpWrong(benef_const.otpInValid)
                    }
                    else {
                        setOtpWrong(benef_const.otpInValid)
                        setMaxLimitMessage(benef_const.otpLimitReached)
                    }
                }
            }
            else if (beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.aadhar) {
                const data = {
                    "otp": result,
                    "txnId": aadharTxnId,
                    "mobileNumber": mobNumber.split(' ')[mobNumber.split(' ').length-1]
                }
                try {
                    setSHowSpinner(true);
                    const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data));
                    const otpResponse = await postDataJSON<any>(`${endpoints.createAbhaViaAadhaarVerify}`, { data: encodedPayload })
                    const decodedData = JSON.parse(decodeWithKeyAndShift(otpResponse.data));
                    const res = decodedData;
                    setSHowSpinner(false);
                    if (res.txnId) {
                        const difference = dayjs().diff(dayjs(decodedData.ABHAProfile.dob,"DD-MM-YYYY"), "year");
                        if (!isChildRegistration && (beneficiary?.beneficiaryGender === GENDER.FEMALE && decodedData.ABHAProfile.gender !== GENDER.female)) {
                            setInvalidGenderMessage(benef_const.genderMisMatchFemale)
                        }
                        else if (!isChildRegistration && (beneficiary?.beneficiaryGender === GENDER.MALE && decodedData.ABHAProfile.gender !== GENDER.male)) {
                            setInvalidGenderMessage(benef_const.genderMisMatchMale)
                        }
                        else if (!decodedData.ABHAProfile.mobile) {
                            handleClose(benef_const.verifyOptions.backToOtherMethod);
                            toast.error(benef_const.aadharNotLinkedToMobile, {
                                position: "top-center"
                            })
                            setIsOTPErrorCheck(false);
                            setMaxLimitMessage('')
                            setRetryMessage('');
                            setSelectedInputFieldValue(Array(6).fill(''));
                            setRetry(3);
                        }
                        else if((!isChildRegistration && difference < benef_const.childMinimumAge) || (isChildRegistration && difference > benef_const.childMinimumAge)){
                            handleAuthClick('close')
                            toast.error(isChildRegistration? benef_const.childBeneficiaryMaxAgeErrorMessage : benef_const.childBeneficiaryRegisterErrorMessage, {
                                position: "top-center"
                            })
                            setIsOTPErrorCheck(false);
                            setMaxLimitMessage('')
                            setRetryMessage('');
                            setSelectedInputFieldValue(Array(6).fill(''));
                            setRetry(3);
                        }
                        else {
                            const trimmedMobileNumber = mobNumber?.split(' ')[mobNumber?.split(' ').length-1];
                            dispatch(setTxnIdForAbhaAddress(res?.txnId));
                            const mobData={
                                mobileNumber:trimmedMobileNumber
                            }
                            const benfData = {
                                name: (decodedData.ABHAProfile.middleName === '' ?
                                    decodedData.ABHAProfile.firstName + " " + decodedData.ABHAProfile.lastName :
                                    decodedData.ABHAProfile.firstName + " " + decodedData.ABHAProfile.middleName + " " + decodedData.ABHAProfile.lastName),
                                abhaId: decodedData.ABHAProfile.ABHANumber.replace('-', ''),
                                gender: decodedData.ABHAProfile.gender,
                                dob: decodedData.ABHAProfile.dob,
                                mob: trimmedMobileNumber,
                                address: decodedData.ABHAProfile.phrAddress[0],
                                profile: decodedData.ABHAProfile.photo,
                                kycVerified: decodedData.ABHAProfile.kycVerified,
                            }
                            dispatch(setBeneficiaryData([benfData]));
                            if (isChildRegistration && decodedData?.ABHAProfile?.photo) {
                                const convertPhotoToFormType = await prepareBeneficiaryImageForDisplay(decodedData?.ABHAProfile?.photo || '');
                                dispatch(updateChild('childImageData', convertPhotoToFormType.formData))
                            }
                            const encodedData = encodeWithKeyAndShift(JSON.stringify(mobData));
                            const mobNumCheckResponse = await postDataJSON<any>(`${endpoints.checkBenefMobileNumberExists}`, {data:encodedData});                            
                            const decodedResponse = JSON.parse(decodeWithKeyAndShift(mobNumCheckResponse.data.data));
                            if (decodedResponse.isBenefExist === false) {
                                dispatch(beneficiaryAlreadyInRCH(false))
                            }
                            else {
                                setLinkedBenefDetails(decodedResponse.benefDetails);
                                dispatch(beneficiaryAlreadyInRCH(true))
                            }
                            setIsOTPErrorCheck(false);
                            setMaxLimitMessage('')
                            setRetryMessage('');
                            setSelectedInputFieldValue(Array(6).fill(''));
                            setRetry(benef_const.defalut_retry);
                            handleClose('submit',decodedData?.ABHAProfile?.ABHANumber?.replace('-', ''), trimmedMobileNumber, decodedData?.ABHAProfile?.phrAddress[0], benfData);
                        }
                    }
                    else {
                        if (retry >= 0) {
                            setOtpWrong(decodedData?.error?.message?.split(':')[2]?decodedData.error.message.split(':')[2]:decodedData?.error?.message || '')
                        }
                        else {
                            setOtpWrong(benef_const.otpInValid)
                            setMaxLimitMessage(benef_const.otpLimitReached)
                        }
                    }
                }
                catch (error) {
                    setSHowSpinner(false);
                    if (retry >= 0) {
                        setOtpWrong(benef_const.otpInValid)
                    }
                    else {
                        setOtpWrong(benef_const.otpInValid)
                        setMaxLimitMessage(benef_const.otpLimitReached)
                    }

                }
            }
            else if (beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.abha) {
                const data = {
                    "otp": result,
                    "txnId": abhaTxnId
                }
                try {
                    setSHowSpinner(true);
                    const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data));
                    const otpResponse = await postDataJSON<any>(`${endpoints.verifyOtpToAbhaToVerifyAbhaV1}`, { data: encodedPayload })
                    const decodedData = JSON.parse(decodeWithKeyAndShift(otpResponse.data));
                    const res = decodedData[0];
                    const resData = decodedData[1];
                    setSHowSpinner(false);
                    if (res.authResult === benef_const.success) {
                        const formattedDate = `${resData.yearOfBirth}-${resData.monthOfBirth}-${resData.dayOfBirth}`;
                        const difference = dayjs().diff(dayjs(formattedDate), "year");
                        if (!isChildRegistration && (beneficiary?.beneficiaryGender !== resData.gender.replace(GENDER.female, GENDER.FEMALE).replace(GENDER.male, GENDER.MALE))) {
                            setInvalidGenderMessage(`The gender mismatch. Please enter the details of a ${beneficiary?.beneficiaryGender}`)
                        }
                        else if((!isChildRegistration && difference < benef_const.childMinimumAge) || (isChildRegistration && difference > benef_const.childMinimumAge)){
                            handleAuthClick('close')
                            toast.error(isChildRegistration ? benef_const.childBeneficiaryMaxAgeErrorMessage : benef_const.childBeneficiaryRegisterErrorMessage, {
                                position: "top-center"
                            })
                            setIsOTPErrorCheck(false);
                            setMaxLimitMessage('')
                            setRetryMessage('');
                            setSelectedInputFieldValue(Array(6).fill(''));
                            setRetry(benef_const.defalut_retry);
                        }
                        else {
                            setSHowSpinner(true);
                            setIsOTPErrorCheck(false);
                            setMaxLimitMessage('');
                            setSelectedInputFieldValue(Array(6).fill(''));
                            setRetryMessage('');
                            setRetry(benef_const.defalut_retry);
                            const benfData = {
                                name: resData.name,
                                abhaId: resData.ABHANumber.replace('-', ''),
                                gender: resData.gender,
                                dob: (resData.dayOfBirth + "-" + resData.monthOfBirth + "-" + resData.yearOfBirth),
                                mob: resData.mobile,
                                address: resData.preferredAbhaAddress,
                                profile: resData.profilePhoto,
                                kycVerified: resData.kycVerified
                            };

                            if (isChildRegistration && resData?.profilePhoto) {
                                const convertPhotoToFormType = await prepareBeneficiaryImageForDisplay(resData?.profilePhoto || '');
                                dispatch(updateChild('childImageData', convertPhotoToFormType.formData))
                            }
                            dispatch(setBeneficiaryData([benfData]));
                            const mobData = {
                                mobileNumber: resData.mobile
                            }
                            const encodedData = encodeWithKeyAndShift(JSON.stringify(mobData));
                            const mobNumCheckResponse = await postDataJSON<any>(`${endpoints.checkBenefMobileNumberExists}`, { data: encodedData });
                            const decodedResponse = JSON.parse(decodeWithKeyAndShift(mobNumCheckResponse.data.data));
                            if (decodedResponse.isBenefExist === true){
                                setLinkedBenefDetails(decodedResponse.benefDetails)
                                dispatch(beneficiaryAlreadyInRCH(true))
                                setSHowSpinner(false);
                                handleClose('show-exist-modal');
                            }else{
                                dispatch(beneficiaryAlreadyInRCH(false))
                                setSHowSpinner(false);
                                handleClose('submit',resData.ABHANumber.replace('-', ''), resData.mobile, resData.preferredAbhaAddress, benfData);
                            }
                        }
                    }
                    else {
                        if (retry >= 0) {
                            setOtpWrong(decodedData?.length > 0 ? (decodedData[0].message || '') : '')
                        }
                        else {
                            setMaxLimitMessage(benef_const.otpLimitReached)
                        }
                    }
                }
                catch (error) {
                    setSHowSpinner(false);
                    if (retry >= 0) {
                        setOtpWrong(benef_const.otpInValid)
                    }
                    else {
                        setOtpWrong(benef_const.otpInValid)
                        setMaxLimitMessage(benef_const.otpLimitReached)
                    }

                }
            }
        }
    }
    useEffect(() => { }, [aadharTxnId])
    useEffect(() => { }, [maxLimitMessage, invalidGenderMessage]);
    useEffect(() => {
    }, [selectedInputFieldValue]);
    const dispatch = useDispatch();
    const handleAuthClick = (authType: string) => {
        setMaxLimitMessage('')
        setInvalidGenderMessage('');
        setSelectedInputFieldValue(Array(6).fill(''));
        setRetry(benef_const.defalut_retry);
        setOtpWrong('');
        setRetryMessage('');
        handleClose(authType);
    };
    const handleTimerEnd = () => {
        setIsTimeFinished(true);
    }
    const restartTimer = async () => {
        try {
            setIsOTPErrorCheck(true);
            if (retry <= 0) {
                setRetryMessage('otp limit reached ');
                setMaxLimitMessage(benef_const.otpLimitReached)
            }

            else {
                setResetKey(prevKey => prevKey + 1);
                setIsTimeFinished(false);
                setRetry(retry - 1);
                setMaxLimitMessage('')
                setOtpWrong('');
                setRetryMessage('');
                setSelectedInputFieldValue(Array(6).fill(''));
                setIndex(0); setIsOTPErrorCheck(false);
                if (beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.phoneNumber) {
                    try {
                        const mobileNumberFormatted = mobNumber.split(' ')[mobNumber.split(' ').length-1];
                        const data = {
                            "mobile": mobileNumberFormatted
                        }
                        const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data));
                        const response = await postDataJSON<any>(`${endpoints.verifyAbhaByMobileNumberSendOtp}`, { data: encodedPayload })
                        const decodedData = JSON.parse(decodeWithKeyAndShift(response.data));
                        const res = decodedData;
                        if (res?.txnId) {
                            dispatch(setTsnID(res.txnId));
                        }
                        else if (res?.message?.includes('does not match')) {
                            handleError(`${decodedData?.code} - ${decodedData.message}`, benef_error_const?.provideCorrectPhone);
                        }
                        else if (res?.message?.includes('30 seconds')) {
                            handleError(res.message);
                        } 
                        else if (res?.message?.includes('multiple OTPs')) {
                            handleError(res.message, benef_error_const?.multipleOTP);
                        } 
                        else if (res?.message?.includes('Missing Credentials')) {
                            handleError(`${res?.code} - ${res.description}`);
                        }
                        else if(res?.message?.includes('Too many request attempted')){
                            handleError(`${res?.message}`);
                        }
                        else if (res?.message?.includes('Aadhaar Gateway is unavailable')) {
                            handleError(res?.message);
                        }
                        else if (res?.message?.includes('Runtime Error')) {
                            handleError(`${decodedData?.code} - ${decodedData.message}`, benef_error_const?.urlNotFound);
                        }
                        else if (res?.loginId?.includes('Invalid LoginId')) {
                            handleError(`${decodedData?.loginId}`, benef_error_const?.provideCorrectPhone);                        
                        }
                        else {
                            handleError(`${decodedData?.message ?? benef_error_const.genericAbdmMessage}` )
                        }
                    } catch (error:any) {
                        if (isOtpRateLimitedError(error)) {
                            startOtpCooldown(mobNumber?.split(' ')?.pop());
                            handleError(otpCooldownMessage);
                            return;
                        }
                        const decodedData = JSON.parse(decodeWithKeyAndShift(error));
                        const res = decodedData;
                        let catchErrorMessage = '';
                        if(res?.message && res?.code){
                            catchErrorMessage =`${res?.code} - ${res?.message}`
                        }else if(res?.message && !res?.code){
                            catchErrorMessage =`${res?.message}`
                        }else if(res?.loginId){
                            catchErrorMessage =`${res?.loginId}`
                        }else if(res?.Aadhaar){
                            catchErrorMessage =`${res?.Aadhaar}`
                        }else{
                            catchErrorMessage = benef_error_const.genericAbdmMessage
                        } 
                        handleError(catchErrorMessage);
                        errorLogger(res, "Phone OTP Generation-verifyAbhaByMobileNumberSendOtp");
                    }
                }
                else if (beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.abha) {
                    try {
                        const encodedPayload = encodeWithKeyAndShift(JSON.stringify(abha));
                        const response = await postDataJSON<any>(`${endpoints.sendOtpToAbhaToVerifyAbha}`, { data: encodedPayload })
                        const decodedData = JSON.parse(decodeWithKeyAndShift(response.data));
                        const res = decodedData;
                        if (res?.txnId) {
                            dispatch(setTsnID(res.txnId));
                        }
                        else if (res?.message?.includes('multiple OTPs')) {
                            handleError(res.message, benef_error_const?.multipleOTP);
                        }
                        else if (res?.message?.includes('30 seconds')) {
                            handleError(res.message);
                        }
                        else if (res?.message?.includes('Runtime Error')) {
                            handleError(`${res?.code} - ${res.message}`, benef_error_const?.urlNotFound);
                        }
                        else if (res?.message?.includes('User not found')) {
                            handleError(`${res?.code} - ${res.message}`, benef_error_const?.provideCorrectAbha);
                        }
                        else if (res?.message?.includes('Missing Credentials')) {
                            handleError(`${res?.code} - ${res.description}`);
                        }
                        else if(res?.message?.includes('Too many request attempted')){
                            handleError(`${res?.message}`);
                        }
                        else if (res?.loginId?.includes('Invalid LoginId')) {
                            handleError(`${res?.loginId}`, benef_error_const?.provideCorrectAbha);
                        }
                        else {
                            handleError(res?.message);
                        }
                    } catch (error:any) {
                        if (isOtpRateLimitedError(error)) {
                            startOtpCooldown(otpCooldownIdentifier);
                            handleError(otpCooldownMessage);
                            return;
                        }
                        const decodedData = JSON.parse(decodeWithKeyAndShift(error));
                        const res = decodedData;
                        let catchErrorMessage = '';
                        if(res?.message && res?.code){
                            catchErrorMessage =`${res?.code} - ${res?.message}`
                        }else if(res?.message && !res?.code){
                            catchErrorMessage =`${res?.message}`
                        }else if(res?.loginId){
                            catchErrorMessage =`${res?.loginId}`
                        }else if(res?.Aadhaar){
                            catchErrorMessage =`${res?.Aadhaar}`
                        }else{
                            catchErrorMessage = benef_error_const.genericAbdmMessage
                        } 
                        handleError(catchErrorMessage);
                        errorLogger(res, "ABHA OTP RESEND-sendOtpToAbhaToVerifyAbha");
                    }
                }
                else {
                    try {
                        const data = {
                            "aadhaar": aadhar
                        }
                        const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data));
                        const response = await postDataJSON<any>(`${endpoints.createAbhaViaAadhaar}`, { data: encodedPayload })
                        const decodedData = JSON.parse(decodeWithKeyAndShift(response.data));
                        const res = decodedData;
                        if(res?.txnId){
                            dispatch(setTsnID(res.txnId));
                        }
                        else if (res?.message?.includes('Runtime Error')) {
                            handleError(`${res?.code} - ${res?.message}`, benef_error_const?.urlNotFound);
                        } else if (res?.message?.includes('30 seconds')) {
                            handleError(res?.message);
                        } else if (res?.message?.includes('multiple OTPs')) {
                            handleError(res?.message, benef_error_const?.multipleOTP);
                        } else if (res?.message?.includes('Missing Credentials')) {
                            handleError(`${res?.code} - ${res?.description}`);
                        } else if(res?.message?.includes('Too many request attempted')){
                            handleError(`${res?.message}`);
                        } else if (res?.message?.includes('Aadhaar Gateway is unavailable')) {
                            handleError(res?.message);
                        } else if (res?.loginId?.includes('Invalid LoginId')) {
                            handleError(res?.loginId, benef_error_const?.provideCorrectAadhaar);
                        } else {
                            handleError(res?.message ?? benef_error_const.genericAbdmMessage);
                        }
                    } catch (error:any) {
                        if (isOtpRateLimitedError(error)) {
                            startOtpCooldown(aadhar);
                            handleError(otpCooldownMessage);
                            return;
                        }
                        const decodedData = JSON.parse(decodeWithKeyAndShift(error));
                        const res = decodedData;
                        let catchErrorMessage = '';
                        if(res?.message && res?.code){
                            catchErrorMessage =`${res?.code} - ${res?.message}`
                        }else if(res?.message && !res?.code){
                            catchErrorMessage =`${res?.message}`
                        }else if(res?.loginId){
                            catchErrorMessage =`${res?.loginId}`
                        }else if(res?.Aadhaar){
                            catchErrorMessage =`${res?.Aadhaar}`
                        }else{
                            catchErrorMessage = benef_error_const.genericAbdmMessage
                        } 
                        handleError(catchErrorMessage);
                        errorLogger(res, "AADHAAR OTP RESEND -createAbhaViaAadhaar");
                    }
                }
            }
        }
        catch(error:any){
            errorLogger(error?.response?.data||error?.response||error)
          }
    }
    const handleOTPInputFieldChange = (value: string, index: number) => {
        const newSelectedInputField = [...selectedInputFieldValue];
        setIsOTPErrorCheck(true);

        if (value.trim()) {
            newSelectedInputField[index] = value.trim();
            setSelectedInputFieldValue(newSelectedInputField);
            setIndex(index + 1);
            const nextInput = document.getElementById(`otp-hpr-abha-${index + 1}`);
            nextInput?.focus();
        }
        else {
            newSelectedInputField[index] = '';
            setSelectedInputFieldValue(newSelectedInputField);
            setIndex(index - 1);
        }
    }
    function handleBackClick(): void {
        handleAuthClick('back');
    }

    function handleDiscardClick(): void {
        handleAuthClick('close');
        dispatch(updateChild('isChildRegistration', false));
    }
    return (

        <>
            <div className="modal_auth_beneficiaries">
                <Modal
                    show={showModal}
                    onHide={() => {
                        handleAuthClick('close')
                        setMaxLimitMessage('')
                        setInvalidGenderMessage('');
                        setOtpWrong('');
                        setSelectedInputFieldValue(Array(6).fill(''));
                        setRetry(benef_const.defalut_retry);
                        setRetryMessage('');
                    }}
                    dialogClassName={'auth-card-modal'}
                    centered={true}
                    backdrop="static"
                >
                    <Modal.Header>
                        <div className='otp_card_header'>
                            <div className="d-flex align-items-center beneficiary_back_button" onClick={handleBackClick}>
                                <i className="bi bi-arrow-left" style={{ cursor: "pointer" }} ></i>
                                <span className="ms-1">Back</span>
                            </div>
                            <div className="d-flex align-items-center beneficiary_discard_button" onClick={handleDiscardClick}>
                                <span className="me-0">Discard</span>
                                <i className="bi bi-x" ></i>
                            </div>

                        </div>
                    </Modal.Header>

                    <Modal.Body  >
                        {(maxLimitMessage === '' && invalidGenderMessage === '') &&
                            <div className="beneficiary-otp-card">
                                <div className='otp_card_heading_container'>
                                    <h1 >Enter OTP</h1>
                                    <h2 >{(beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.abha)?mobNumber:mobNumber?.substring(0, mobNumber?.lastIndexOf(" "))}</h2>
                                </div>
                                <div className="beneficiary-otp-page-content">
                                    {Array.from({ length: 6 }).map((_, index) => (
                                        <div className="beneficiary-otp-page-content-input-fields" key={index}>
                                            <InputFieldsComponent
                                                className={
                                                    selectedInputFieldValue[index]
                                                        ? 'ip-fields-has-value'
                                                        : 'ip-fields'
                                                }
                                                placeholder={'_'}
                                                type={'number'}
                                                isDisabled={false}
                                                inputId={`otp-hpr-abha-${index}`}
                                                value={selectedInputFieldValue[index] || ''}
                                                onChange={(value: string) => handleOTPInputFieldChange(value, index)}
                                                maximumLength={1}
                                            />
                                        </div>
                                    ))}
                                </div>
                                <div className="otp-resend">
                                    <div className='otp_resend_container'>

                                        <h2>Didn't receive an OTP</h2>
                                        <span> {isTimeFinished ?
                                            otpWrong !== '' ?
                                                <div className="divbutton">
                                                    <Button
                                                        onClick={restartTimer}
                                                        disabled={isCoolingDown}
                                                        id=""
                                                        buttonName={`${otpWrong}. Resend OTP`}
                                                        colorType={'save'}
                                                        icon={''}
                                                        iconPosition={''}
                                                    />
                                                </div> :
                                                <Button
                                                    onClick={restartTimer}
                                                    disabled={isCoolingDown}
                                                    id=""
                                                    buttonName={'Resend OTP'}
                                                    colorType={'save'}
                                                    icon={''}
                                                    iconPosition={''}
                                                /> : otpWrong === '' ?
                                                <Button
                                                    onClick={() => { }}
                                                    disabled={true}
                                                    id=""
                                                    buttonName={`Resend OTP in`}
                                                    colorType={'save'}
                                                    icon={''}
                                                    iconPosition={''}
                                                /> :
                                                <Button
                                                    onClick={restartTimer}
                                                    disabled={true}
                                                    id=""
                                                    buttonName={`${otpWrong}. Resend OTP in`}
                                                    colorType={'save'}
                                                    icon={''}
                                                    iconPosition={''}
                                                />

                                        }</span>


                                        <span><Time startTime={60} resetKey={resetKey} onTImeEnd={handleTimerEnd} /></span>
                                    </div>
                                    <span className="no_of_retries_resend_otp">Retries left : {retry >= 0 ? retry : 0}</span>
                                    { }
                                    <span className="no_of_retries_resend_otp">{retryMessage}</span>
                                    {isCoolingDown && (
                                        <p style={{ color: '#b42318', fontSize: '12px', margin: '8px 0 0' }}>
                                            You can request for new OTP after {secondsLeft} seconds
                                        </p>
                                    )}
                                </div>
                                <span>{showSpinner && (<><span>Loading...</span><Spinner /></>)} </span>
                                <div className="beneficiary-otp-page-button">
                                    <Button
                                        onClick={handleSave2}
                                        disabled={false}
                                        id="beneficiary-otp-page-Submit-button"
                                        buttonName={'Submit'}
                                        colorType={'primary'}
                                        icon={''}
                                        iconPosition={''}
                                    />
                                </div>
                            </div>}
                        {maxLimitMessage !== '' &&
                            <div>
                                {maxLimitMessage}
                                <div className="beneficiary-otp-page-button">
                                    <Button
                                        onClick={() => handleAuthClick('close')}
                                        disabled={false}
                                        id="beneficiary-otp-page-Submit-button"
                                        buttonName={'Close'}
                                        colorType={'primary'}
                                        icon={''}
                                        iconPosition={''}
                                    />
                                </div>
                            </div>}
                        {invalidGenderMessage !== '' &&
                            <div>
                                {invalidGenderMessage}
                                <div className="beneficiary-otp-page-close-button">
                                    <Button
                                        onClick={() => handleAuthClick('close')}
                                        disabled={false}
                                        id=""
                                        buttonName={'Close'}
                                        colorType={'primary'}
                                        icon={''}
                                        iconPosition={''}
                                    />
                                </div>
                            </div>}
                    </Modal.Body>
                </Modal>
            </div>
        </>
    )
}

export default OTPModal;
